module.exports = __webpack_public_path__ + "static/media/CSVMedewerkerExample.0cb8871f.csv";